import React from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";
const ConsultBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          {/* Preloaded Image for Faster Rendering */}
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/7.%20Consultation.webp"
            alt="Consultation Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />

          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-xxl-5 mt-3">
              <p className="fs4 text-uppercase busy">TAILORED CONSULTATION</p>
              <HeadingH1 className="banner-headings">
                Maximize Your Travel Potential
              </HeadingH1>
              <div className="d-flex common-second-content consultation">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Is your travel plan working for you? Let our consultants guide
                  you towards smarter business travel solutions—saving time,
                  reducing costs, and boosting productivity.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default ConsultBanner;
